import { render, staticRenderFns } from "./NeedsList.vue?vue&type=template&id=16ee56a0&"
import script from "./NeedsList.vue?vue&type=script&lang=js&"
export * from "./NeedsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedsList.vue"
export default component.exports